import React, { Component, PropTypes } from 'react';
import Modal from 'common/components/Modal';
import PointForm from './forms/PointForm';
import CommentForm from './forms/CommentForm';
import 'plugins/forms';

class EditPointModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isUpdating: false,
      isDeleting: false,
    };

    this._onChangeImage = this._onChangeImage.bind(this);
    this._onSubmit = this._onSubmit.bind(this);
    this._onDelete = this._onDelete.bind(this);
  }

  _onChangeImage(file) {
    this._file = file;
  }

  _onSubmit(evt) {
    evt.preventDefault();

    this.setState({
      isUpdating: true,
    });
  }

  _onDelete(evt) {
    evt.preventDefault();

    this.setState({
      isDeleting: true,
    });
  }

  render() {
    const { point, disabled } = this.props;

    let content;

    if (point.type === 'point') {
      content = <PointForm point={point} disabled={disabled} />;
    } else {
      content = (
        <CommentForm
          comment={point}
          disabled={disabled}
          onChangeImage={this._onChangeImage}
        />
      );
    }

    return (
      <Modal isOpened closable>
        <div className="header">{point.name}</div>
        <div className="content">{content}</div>
      </Modal>
    );
  }
}

EditPointModal.propTypes = {
  point: PropTypes.object.isRequired,
};

export default EditPointModal;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/plan/components/EditPointModal.js